import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { PawPrint } from "lucide-react";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center max-w-md mx-auto p-6">
        <div className="flex justify-center mb-4">
          <div className="bg-pet-purple/10 p-4 rounded-full">
            <PawPrint className="h-12 w-12 text-pet-purple" />
          </div>
        </div>
        
        <h1 className="text-5xl font-bold text-pet-purple mb-2">{t('notFound.title')}</h1>
        <p className="text-xl text-gray-700 mb-2">{t('notFound.subtitle')}</p>
        <p className="text-gray-500 mb-6">
          {t('notFound.description')}
        </p>
        
        <div className="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-2 justify-center">
          <Button asChild variant="default" className="bg-pet-purple hover:bg-pet-purple/90">
            <Link to="/">{t('notFound.backToHome')}</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/my-pets">{t('notFound.myPets')}</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
